import React from 'react';
import './rideLogoFloat.css';

// The Ride ATL moving logo (locked 2026-10-25): the real logo disc under curved glass, lifted above a shadow pool, rising and
// settling gently. The Ride's brand only: other tenants keep their own logo image. The <img> keeps whatever class the caller
// passes, so existing selectors and tests that look for it still find it. Decorative layers are aria-hidden.
export default function RideLogoFloat({ src, alt, imgClassName = '', className = '', onError }) {
    return (
        <div className={`ride-float ${className}`.trim()} data-testid="ride-logo-float">
            <span className="ride-float__pool" aria-hidden="true" />
            <div className="ride-float__disc">
                <div className="ride-float__lens">
                    <img className={`ride-float__img ${imgClassName}`.trim()} src={src} alt={alt} onError={onError} />
                    <span className="ride-float__vignette" aria-hidden="true" />
                    <span className="ride-float__reflection" aria-hidden="true" />
                </div>
            </div>
        </div>
    );
}
